<template>
  <div class="form_field flex_field border-bottom full">
    <div>
      <div class="label_container pb-14">
        <label for="">Altre informazioni utili per perfezionare la quotazione</label>
      </div>
      <div class="input_container checkbox_container_car_list">
        <label class="input-checkbox" v-for="(value, key) in notes" :key="key">
          <span>{{ value }}</span>
          <input type="checkbox" :name="`equip[${key}]`" value="1" />
          <span class="checkmark_checkbox"></span>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarNotes',
  props: {
    notes: {
      type: Object,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/CarNotes.vue